module.exports = __webpack_public_path__ + "static/media/kristina.7fbddc7a.jpg";